import React from 'react';
import { PURCHASE_RESPONSE } from 'shared/constants';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { useTheme } from 'styled-components';
import Button from '../../../../../../components/Button/Button';
import Modal from '../../../../../../components/JSModal';
import { isNotStandaloneMobilePWA } from '../../../../../../utils/mobileSupported';
import RespopnseHeader from './header';
import {
  ContentWrapper,
  errorModalMainBodyStyle,
  errorModalMainBodyStyleSmallScreen,
  highlightedHeaderContainerStyle,
  highlightedHeaderHeight,
  IconWrapper,
  MainContainer,
  MessageContainer,
  MessageIcon,
  modalStyle,
  successModalMainBodyStyle,
  successModalMainBodyStyleSmallScreen,
  VipPurchaseSuccessAccessText,
  VipSuccessAsset,
  VipSuccessAssetWrapper,
} from './styledComponents';

const PurchaseResponsePopUp = ({
  purchaseResponse,
  onDismissPurchaseResponse,
  setIsPurchaseButtonDisabled,
  rewardCenterAssets,
  isVipSuccessPurchase,
  onVipOfferPlayButton,
}) => {
  const RENDER_CONFIG = {
    [PURCHASE_RESPONSE.SUCCESS]: {
      headerText: getText(TEXT_KEY.CONGRATULATIONS),
      assetSource: isVipSuccessPurchase
        ? assetSource(ASSET_KEY.PURCHASE_SUCCEEDED)
        : rewardCenterAssets.REWARD_CENTER_PURCHASE_SUCCESS,
      buttonText: isVipSuccessPurchase ? getText(TEXT_KEY.PLAY_NOW) : getText(TEXT_KEY.DONE),
      modalStyle: isNotStandaloneMobilePWA ? successModalMainBodyStyleSmallScreen : successModalMainBodyStyle,
    },
    [PURCHASE_RESPONSE.ERROR]: {
      headerText: getText(TEXT_KEY.OOPS),
      buttonText: getText(TEXT_KEY.OK),
      modalStyle: isNotStandaloneMobilePWA ? errorModalMainBodyStyleSmallScreen : errorModalMainBodyStyle,
    },
  };

  const renderConfig = RENDER_CONFIG[purchaseResponse.status] || {};

  const handleDismissPurchaseResponse = () => {
    onDismissPurchaseResponse();
    setIsPurchaseButtonDisabled(false);
  };

  const themeContext = useTheme();

  return (
    <Modal
      isVisible={true}
      onBackButtonPress={() => onDismissPurchaseResponse(null)}
      style={modalStyle}
      modalMainBodyStyle={renderConfig.modalStyle}
      hideCloseButton={isVipSuccessPurchase ? false : true}
    >
      <MainContainer>
        <MessageContainer>
          {!isVipSuccessPurchase && (
            <RespopnseHeader
              containerStyle={highlightedHeaderContainerStyle}
              wrapperStyle={themeContext.OfferDetail.PurchaseResponseHighlightHeader}
              headerTitleWrapperStyle={themeContext.OfferDetail.PurchaseResponseHeader}
              dividerAsset={assetSource(ASSET_KEY.SHOP_VIP_DIVIDER_GLOWS)}
              headerHeightStyle={highlightedHeaderHeight}
              title={renderConfig.headerText}
            />
          )}
          <ContentWrapper>
            {renderConfig.assetSource &&
              (isVipSuccessPurchase ? (
                <VipSuccessAssetWrapper>
                  <VipSuccessAsset alt="" src={renderConfig.assetSource} />
                </VipSuccessAssetWrapper>
              ) : (
                <IconWrapper>
                  <MessageIcon alt="" src={renderConfig.assetSource} />
                </IconWrapper>
              ))}
            {isVipSuccessPurchase && (
              <VipPurchaseSuccessAccessText>{getText(TEXT_KEY.ACCESS_GRANTED)}</VipPurchaseSuccessAccessText>
            )}
            <div style={themeContext.OfferDetail.RewardCenterPurchaseResponseMessage}>{purchaseResponse.message}</div>
            <Button
              onClick={isVipSuccessPurchase ? onVipOfferPlayButton : handleDismissPurchaseResponse}
              containerStyle={{
                margin: '1em auto',
                position: 'relative',
                textAlign: 'center',
                cursor: 'pointer',
                pointerEvents: 'auto',
                width: '10em',
                height: '14%',
                paddingTop: purchaseResponse.status === PURCHASE_RESPONSE.SUCCESS ? 0 : '3.4em',
              }}
              imageStyle={{ width: '100%', height: '100%' }}
              imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
              label={renderConfig.buttonText}
            />
          </ContentWrapper>
        </MessageContainer>
      </MainContainer>
    </Modal>
  );
};

export default PurchaseResponsePopUp;

